// import axios from "axios";
// const API = axios.create({ baseURL: 'https://inspiredformenserver.onrender.com'});

import axios from "axios";
const API = axios.create({ baseURL: 'https://api.inspiredformen.com/api' });

export const fetchPost = (topic) => API.get(`/posts/${topic}`);

export const fetchPosts = () => API.get('/posts');

// likes
export const fetchLikes = (postId) => API.get(`/likes?postId=${postId}`);
export const addLike = (postId) =>
    API.post(`/likes`, { postId }, { withCredentials: true });

export const deleteLike = (postId) =>
    API.delete(`/likes?postId=${postId}`, { withCredentials: true });

// export const comment = (value, id) => API.post(`/posts/${id}/commentPost`, value);
export const fetchComments = (postId) => API.get(`/comments?postId=${postId}`);
export const createComment = (postId, newComment) => API.post(`/comments?postId=${postId}`, newComment);


export const signIn = (values) => API.post('/auth/login', values, { withCredentials: true })
export const signUp = (values) => API.post('/auth/register', values)
export const logout = () => API.post('/auth/logout', {}, { withCredentials: true });



// API.interceptors.request.use((req) => {
//     if(localStorage.getItem('profile')){
//         req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`;
//     }

//     return req;
// })




